export const CountryCode = {
  NORWAY: 'NO',
  SWEDEN: 'SE',
  GERMANY: 'DE'
} as const;

export type CountryCodeType = (typeof CountryCode)[keyof typeof CountryCode];

export const TIRE_SET_OFFER_ADMIN_VIEW_PARAM = 'adminView';
